var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-layout",class:_vm.classes},[_c('div',{staticClass:"sidebar-layout__sidebar-wrapper"},[_c('sidebar')],1),_c('div',{staticClass:"sidebar-layout__views-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }